import api, { API_ENDPOINTS } from '../apis/constants';
import { RegisterData, User } from '../context/AuthContext';

interface LoginResponse {
    token: string;
    user: User;
}

interface RegisterResponse {
    id: string;
    email: string;
    role: string;
}

const authService = {
    // Login user
    async login(email: string, password: string): Promise<LoginResponse> {
        try {
            const response = await api.post(API_ENDPOINTS.AUTH.LOGIN, {
                email,
                password
            });
            return response.data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    },

    // Register new user
    async register(userData: RegisterData): Promise<RegisterResponse> {
        try {
            const response = await api.post(API_ENDPOINTS.AUTH.REGISTER, userData);
            return response.data;
        } catch (error) {
            console.error('Registration error:', error);
            throw error;
        }
    },

    // Set auth token to storage (always use localStorage)
    setToken(token: string): void {
        localStorage.setItem('auth_token', token);
    },

    // Get auth token from localStorage
    getToken(): string | null {
        return localStorage.getItem('auth_token');
    },

    // Clear auth token
    clearToken(): void {
        localStorage.removeItem('auth_token');
    },

    // Store user in local storage
    setUser(user: User): void {
        localStorage.setItem('fruitshop_user', JSON.stringify(user));
    },

    // Get user from local storage
    getUser(): User | null {
        const userJson = localStorage.getItem('fruitshop_user');
        return userJson ? JSON.parse(userJson) : null;
    },

    // Clear user from local storage
    clearUser(): void {
        localStorage.removeItem('fruitshop_user');
    },

    // Check if user is authenticated
    isAuthenticated(): boolean {
        return !!this.getToken();
    },
};

export default authService; 